module.exports = __webpack_public_path__ + "media/images/game/categories/domacnost-b7b0bc35d113c7f4a4923ef7408419e1.png";